module.exports = __webpack_public_path__ + "img/security.063e01c.png";